<template>
  <div class="live-matches-page">
    <LiveNav @changeCat="handleOnChange" @categoryData="categoryData" />
    <div class="home-center-match flex-1">
      <el-carousel
        ref="carousel"
        trigger="click"
        :interval="3000"
        class="carousel-container"
        :height="carouselHeight + 'px'"
      >
        <el-carousel-item v-for="item in homeBg" :key="item.name">
          <img
            class="carousel-img"
            @click="handleCarouseImg(item)"
            :class="isNavShow ? 'show' : 'no-show'"
            :src="item.image_url"
          />
        </el-carousel-item>
      </el-carousel>

      <!-- 全部直播轮播 -->
      <el-carousel
        class="content match-starting"
        trigger="click"
        :interval="6000"
        height="1.68rem"
        arrow="always"
      >
        <el-carousel-item
          class="match-container"
          v-for="(items, i) of hotMatch"
          :key="i"
        >
          <LiveItemS
            class="match-item"
            :hot-match-item="item"
            v-for="item of items"
            :key="item.id"
          />
        </el-carousel-item>
      </el-carousel>

      <!-- 热门赛事直播 -->
      <div class="content venom-panel">
        <div class="live-item-title">
          <img :src="require('@/assets/home/hotLive.png')" />
          <div class="title-content">{{ $t("pc.allLiving") }}</div>
          <div class="category-div">
            <div
              class="type-btn flex-middle"
              :class="{ select: navCategory.firstId === 0 }"
              @click="
                changeCategoryId({
                  firstId: 0,
                  secondId: 0,
                  name: $t('pc.all'),
                })
              "
            >
              {{ $t("pc.all") }}
            </div>
            <div
              v-for="(items, index) of categories"
              :key="index"
              class="type-btn flex-middle"
              :class="{ select: navCategory.firstId === items.id }"
              @click.stop="
                changeCategoryId({
                  firstId: items.id,
                  secondId: 0,
                  name: items.name,
                })
              "
            >
              {{ items.name }}
            </div>
          </div>
        </div>

        <ul class="flex-middle-only sub-cat-content">
          <li
            class="sub-cat-item flex-middle"
            v-for="cate of subCategories"
            :key="cate.id"
            :class="{ active: cate.id === navCategory.secondId }"
            @click.stop="changeCategoryId({ secondId: cate.id })"
          >
            {{ cate.name }}
          </li>
        </ul>

        <div class="no-data" v-if="listData.length === 0 && isListDataLoaded">
          <img src="@/assets/live/no_data.png" alt="" />
          <div>{{ $t("noLive.forNow") }}</div>
        </div>
        <el-row
          :gutter="16"
          v-loading="loading"
          v-else
          class="live-list live-match"
        >
          <el-col
            :span="4"
            class="live"
            v-for="(live, index) of listData"
            :key="index"
          >
            <LiveItemHot :live="live" />
          </el-col>
        </el-row>
        <div class="match-page flex-middle" v-if="total > 0">
          <LivePagination
            :total="total"
            :pageSize="pageSize"
            :setPage="handleCurrentChange"
            :currentPage="page"
          />
          <!-- <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
          <el-button class="go-to-page" @click="getLiveList(true)"
            >GO</el-button
          > -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LiveItemS from "@/components/live-item/live-item-s";
import LiveItemHot from "@/components/live-item/live-item-hot";
import LiveNav from "@/components/live-nav/live-nav";
import { post } from "@/util/http";
import { mapMutations, mapState } from "vuex";
import LivePagination from "@/components/pagination";

export default {
  metaInfo() {
    // return {
    //   title: "体育比赛直播_体育赛事视频直播-猎鹰直播",
    // };
  },
  components: {
    LiveItemS,
    LiveItemHot,
    LiveNav,
    LivePagination,
  },

  data() {
    return {
      timeOut: {},
      hotMatchTime: null,
      hotMatch: [],
      page: 1,
      total: 0,
      pageSize: 60,
      loading: true,
      listData: [],
      changeCategory: false,
      categories: [],
      isListDataLoaded: false,
      homeBg: "",
      carouselHeight: 187,
    };
  },
  computed: {
    ...mapState(["navCategory", "isNavShow", "userInfo"]),
    subCategories() {
      const currentCate =
        this.categories.find((cate) => this.navCategory.firstId === cate.id) ||
        {};

      let subList = [...(currentCate.second_category || [])];

      if (subList.length > 0) {
        subList.unshift({ id: 0, name: this.$t("pc.all") });
      }

      return subList;
    },
  },
  methods: {
    ...mapMutations(["changeNavCategoryName"]),
    handleCarouseImg(item = {}) {
      const { jump_url = "", jump_type = 2 } = item;
      // console.log(item)
      let url = jump_url || "";
      let v =
        /^(https?:\/\/)([0-9a-z.]+)(:[0-9]+)?([/0-9a-z.]+)?(\?[0-9a-z&=]+)?(#[0-9-a-z]+)?/gim;
      if (v.exec(url) && jump_type == 2) {
        window.open(url);
      } else if (url && jump_type == 1) {
        this.$router.push(url);
      }
    },
    async getHomeBanner() {
      const {
        data: { data },
      } = await post({
        url: "/api/ads/getAds",
        data: { equipment: 1, category: 10 },
      });
      if (data) {
        this.homeBg = data;
      }
    },

    updateHistory() {
      const origin = window.location.origin;
      const path = window.location.pathname;
      const url = `${origin}${path}?f=${this.navCategory.firstId}&s=${this.navCategory.secondId}`;

      window.history.pushState("", "", url);
    },

    categoryData(data) {
      this.categories = data;
      console.log("categories=====>>>>", data);
    },

    handleOnChange() {
      this.page = 1;
      this.getLiveList();
    },

    changeCategoryId(obj) {
      this.changeNavCategoryName(obj);
      this.page = 1;
      this.getLiveList();
    },

    handleCurrentChange(val) {
      this.page = val;
      this.getLiveList();
    },

    getLiveList(flag = true) {
      this.loading = flag;

      if (this.loopTimer) {
        clearTimeout(this.loopTimer);
        this.loopTimer = null;
      }

      const params = {
        // 一级分类
        cateid: this.navCategory.firstId ?? 0,
        // 二级分类
        categoryid: this.navCategory.secondId ?? 0,
        page: this.page,
        size: this.pageSize,
        uid: this.userInfo.id || 0,
      };

      this.updateHistory();

      post({
        url: "/api/live/list",
        data: params,
      })
        .then((result) => {
          if (result.status === 200) {
            const res = result.data;
            if (res.status === 0) {
              this.listData = res.data?.LiveList ?? [];
              this.total = res.data?.total;
            }
          }
        })
        .finally(() => {
          this.isListDataLoaded = true;
          this.loading = false;
          this.loopTimer = setTimeout(() => {
            this.getLiveList(false);
          }, 30000);
        });
    },

    getHotMatch() {
      let liveAnchors = Array.from({ length: 5 });
      post({
        url: "/api/match/getHotMatchCards4Crawler",
      }).then(({ data = [] }) => {
        const list = (data.data || []).map((item) => {
          let arr = [];

          if (item.anchor_ids) {
            const anchor_ids = item.anchor_ids.split(",");
            const anchor_avatars = item.anchor_avatars.split(",");

            liveAnchors.forEach((v, index) => {
              const anchor = {};
              if (anchor_ids[index]) anchor.anchor_id = anchor_ids[index];
              if (anchor_avatars[index])
                anchor.anchor_avatar = anchor_avatars[index];

              arr.push(anchor);
            });
          }

          item.liveAnchors = arr;

          return item;
        });

        const ln = list.length % 5;

        // 5个比赛为一组
        this.hotMatch = Array.from({
          length: ln === 0 ? list.length / 5 : Math.floor(list.length / 5) + 1,
        }).map((v, i) => list.slice(i * 5, (i + 1) * 5));

        console.log("this.hotMatch=======>", this.hotMatch);
      });
    },
  },
  watch: {
    volume(newVal) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.player.volume(newVal / 100);
      }, 200);
    },
    "userInfo.id": {
      handler(n, o) {
        this.getLiveList();
        // this.$store.dispatch("checkAnchorStatus");
      },
    },
  },

  created() {
    this.getHotMatch();
    this.getLiveList();
    this.getHomeBanner(); //动态banner
    this.loopTimer = null;
  },

  mounted() {
    this.$nextTick(() => {
      this.carouselHeight = this.$refs["carousel"]?.$el.clientWidth * 0.1043;
    });
    window.addEventListener("resize", () => {
      this.$nextTick(() => {
        this.carouselHeight = this.$refs["carousel"]?.$el.clientWidth * 0.1043;
      });
    });
  },
};
</script>

<style lang="scss">
@import "../../assets/variable.scss";

.home-center-match {
  padding-right: 0.3rem;
  overflow-y: scroll;
  padding-left: 0.3rem;
  margin-left: -0.3rem;

  .carousel-container {
    width: 100%;
    margin: 0.21rem 0 0.28rem 0;
    background: #eeeeee;
    border-radius: 4px;

    .carousel-img {
      width: 100%;
      height: 100%;
      display: block;
    }

    .el-carousel__indicator--horizontal {
      &.is-active {
        .el-carousel__button {
          background: rgba(255, 56, 56, 1);
          width: 0.32rem;
        }
      }
    }

    .el-carousel__button {
      width: 0.1rem;
      height: 0.08rem;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 1px;
      backdrop-filter: blur(2px);
      opacity: 1;
    }
  }

  // 直播滚动
  .match-starting {
    width: 100%;
    position: relative;
    padding: 0 0.4rem;

    .el-carousel__indicators {
      display: none;
    }

    .match-container {
      display: flex;
      //justify-content: space-between;
      align-items: center;
    }

    .match-item {
      margin-left: 8px;
      width: 20%;

      &:first-child {
        margin-left: 0;
      }
    }

    .el-carousel__arrow {
      height: 1.68rem;
      width: 0.32rem;
      transition: 0.3s;
      border-radius: 4px;
      background: linear-gradient(90deg, #fafafa 0%, #ffffff 100%);
      border: 1px solid #eeeeee;
      box-shadow: -2px 0px 5px rgba(0, 0, 0, 0.03);

      .el-icon-arrow-left,
      .el-icon-arrow-right {
        color: #ccc;
        font-size: 21px;
        font-weight: 900;
      }
    }

    .el-carousel__arrow--left {
      left: -0.4rem;
      &:hover {
        background-color: #fbfbfb;
        background-clip: padding-box, border-box;
        background-origin: padding-box, border-box;
        background-image: linear-gradient(to right, #fff, #fff),
          linear-gradient(90deg, #fd3061 0%, #cf2d54 100%);
        border: 1px solid transparent;
        .el-icon-arrow-left {
          color: #fd3061;
        }
      }
    }

    .el-carousel__arrow--right {
      right: -0.4rem;
      &:hover {
        background-color: #fbfbfb;
        background-clip: padding-box, border-box;
        background-origin: padding-box, border-box;
        background-image: linear-gradient(to right, #fff, #fff),
          linear-gradient(90deg, #fd3061 0%, #cf2d54 100%);
        border: 1px solid transparent;
        .el-icon-arrow-right {
          color: #fd3061;
        }
      }
    }
  }
}

.match-page {
  padding: 0.2rem 0;

  /* .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: rgba(208, 45, 84, 1);
  }

  .go-to-page {
    width: 0.42rem;
    height: 0.32rem;
    background: rgba(208, 45, 84, 1);
    border-radius: 2px;
    padding: 0;
    color: #fff;
    margin-left: 0.1rem;
  } */
}

/* ::v-deep {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: rgba(208, 45, 84, 1);
  }

  .el-loading-spinner .path {
    stroke: rgba(208, 45, 84, 1);
  }
} */

.no-data {
  width: 100%;
  min-height: 50vh;
  color: #999;
  font-size: 0.18rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 1.8rem;
    height: 1.8rem;
  }
}

.live-matches-page {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
  padding-top: 0.66rem;
  background: #fff;
  display: flex;
}

.live-item-title {
  display: flex;
  align-items: center;
  padding: 0.24rem 0 0.12rem 0;

  img {
    width: 0.28rem;
    height: 0.28rem;
    padding-right: 0.1rem;
  }

  .title-content {
    font-size: 0.2rem;
    color: #333333;
    letter-spacing: 0;
    font-weight: 700;
    margin-right: 0.6rem;
  }

  .matchType {
    /* width: 60px; */
    height: 24px;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #666;
    margin-right: 8px;
    cursor: pointer;
    border: 1px solid #f0f0f0;
    border-radius: 12.5px;
  }

  .selectedType {
    background: #26d99d;
    color: #fff;
    border: none;
  }

  .category-div {
    display: flex;

    .type-btn {
      margin-right: 0.24rem;
      font-size: 0.14rem;
      padding: 0 0.29rem;
      color: #999;
      border: 1px solid #e2e4e4;
      background-color: #fff;
      height: 0.4rem;
      border-radius: 0.4rem;
      cursor: pointer;

      &:hover {
        /* border-image: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%); */
        background-clip: padding-box, border-box;
        background-origin: padding-box, border-box;
        background: linear-gradient(101.98deg, #ff3838 10.8%, #d02d54 95.33%);

        border: 1px solid transparent;
        color: rgba(255, 255, 255, 1);
      }

      &.select {
        background: linear-gradient(101.98deg, #ff3838 10.8%, #d02d54 95.33%);
        color: #ffffff;
      }
    }
  }
}

.sub-cat-content {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 0.1rem;
}

.sub-cat-item {
  /* width: 0.96rem; */
  padding: 0 0.24rem;
  height: 0.32rem;
  color: #666;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 0.08rem;

  &:first-child {
    margin-left: 0;
  }

  &.active {
    color: #fff!important;
    background: linear-gradient(101.98deg, #FF3838 10.8%, #D02D54 95.33%);

    border-color: #FF3838;
  }

  &:hover {
    border-color: #FF3838;
    color: #FF3838;
  }
}

.activity-item {
  margin-right: 16px;
  border-radius: 16px;
  cursor: pointer;
}

.activity-item-img {
  width: 296px;
  height: 160px;
  border-radius: 16px;
}

.live-content {
  display: flex;
  justify-content: space-between;
  margin-top: -10px;
}

.live-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  // min-height: 5rem;

  .live {
    transition: all 0.2s;
    margin-bottom: 0.32rem;
  }
}

.swiper-activity {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.activity-item {
  box-sizing: border-box;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 0.2rem;
}

.swiper-activity:nth-child(5) {
  margin-right: 0;
}

.activity-item-img {
  width: 2.6rem;
  height: 1.1rem;
  object-fit: cover;
  border-radius: 0.05rem;
  border: 0.02rem solid transparent;

  &:hover {
    border-color: #02a8a2;
  }
}

.show,
.no-show {
  width: 100%;
}
</style>
